///<reference path="../html5controls/Controls/inforShared/js/globalize.js"/>
///<reference path="./Resx.js"/>
///<reference path="./accessibility.js"/>
///<reference path="./Ping.js"/>
///<reference path="./Logging.js"/>
///<reference path="../node_modules/@yggdrasil/core/bundles/yggdrasil-core.js"/>

var instance = window;
function IsMingle() {
  return top != window;
}
function IsStandAlone() {
  return !IsMingle();
}
//
//If using workspace, publish the context message
//
function PublishContextMessage(type, data) {
  if (window.contextMessaging) {
    window.contextMessaging.PublishContextMessage(type, data);
  }
}
function GetSupportId(moniker) {
  if (window.contextMessaging) {
    return window.contextMessaging.GetSupportId(moniker);
  }
}

var emptyTimeRegex = new RegExp("[hmst]", "gi");
var emptyDateRegex = new RegExp("[dmy]", "gi");
// the main window that has the menu bars and everything.  undefined means that this current window is the main window
var _mainWindow = undefined;
// the window to log to
var _logWindow = undefined;
var _logging = false;
var _severity = 16; // error
var runtimeMode = "Deployment";
// Flag set to true if any of the added events involve user activity (for the purposes of session timeout)
var _EventsHaveUserActivity;
// Flag set to true if the previous request involves user activity.
// This will be null after the cblock page load completes.
var _PostbackHasUserActivity;
//set title if modal dialog box or set the window.opener if its supposed to be a modal window
if (window.dialogArguments) {
  if (typeof window.dialogArguments[0] == "string") {
    this.document.title = window.dialogArguments[0];
    if (window.dialogArguments.opener) _mainWindow = window.dialogArguments.opener;
  } else {
    window.opener = window.dialogArguments;
    _mainWindow = window.dialogArguments;
  }
} else if (isChildWindow()) {
  _mainWindow = window.opener;
}
//We need to define this so that we can test for when we are forcing the login page to be displayed.
//We actually assign this variable a value in a <script> tag in hframe.htm, dframe.htm, etc.
var forceLogin;
try {
  if (instance.frameElement && instance.frameElement.getAttribute("isModalDiv")) {
    instance.isModalDiv = true;
    instance.document.documentElement.className = "modalDiv";
    instance.modalDivContext = instance.frameElement.modalDivContext;
    instance.opener = instance.frameElement.opener;
    instance.dialogArguments = instance.frameElement.dialogArguments;
    instance.dialogArguments.opener = instance.frameElement.opener;
  }
} catch (e) {
  // we are going to get an exception when a frame element exists but it is not ours  (this happens in Ming.le on the top page)
}
// loads up IPS application instance
function _loadMainFrame() {
  if (document && document.location) {
    var query = document.location.search;
    var path = "";
    try {
      if (_mainWindow && _mainWindow.instance) {
        path = _mainWindow.instance._AppPath;
      }
    } catch (err) {}
    // Forward any query strings to the cblock
    if (!window.frames["cblock"]) return;
    if (query.length > 0) {
      if (query.indexOf("%3f") == -1) {
        //( query.indexOf( "cBind=" ) > -1 ) // Bypass for generic popups and zoomed info viewers
        window.frames["cblock"].document.location.replace(path + "CBlock.aspx?noop=true");
        var viewIndex = query.indexOf("view=");
        if (viewIndex >= 0) {
          var url = query.substr(viewIndex + 5);
          GetViewDocument().location.replace(path + "vframe.htm?navifwd=" + url);
        } else {
          window.frames["cblock"].document.location.replace(path + "CBlock.aspx" + query);
        }
      } else if (query.indexOf("view=") > -1) {
        window.frames["cblock"].document.location.replace(path + "CBlock.aspx?noop=true");
        var url = decodeURIComponent(query.substr(query.indexOf("view=") + 5));
        var split = url.indexOf("?");
        if (split > -1) {
          url = url.substr(0, split) + "&" + url.substr(split + 1);
        }
        GetViewDocument().location.replace(path + "vframe.htm?navifwd=" + url);
      } // Standard window with a query string
      else {
        window.frames["cblock"].document.location.replace(path + "CBlock.aspx" + query);
      }
      // Remove the Hansen menu
      if (window.frames["menuAndView"].removeMenu) window.frames["menuAndView"].removeMenu();
    } else if (forceLogin != undefined) {
      if (forceLogin == true) {
        window.frames["cblock"].document.location.replace(path + "CBlock.aspx?forceLogin=true");
        forceLogin = false;
      }
    } else {
      // Standard window, no query string
      window.frames["cblock"].document.location.replace(path + "CBlock.aspx");
    }
    if (IsMingle()) {
      var banner = document.getElementById("topBanner");
      banner.parentNode.removeChild(banner);
    } else {
      var button = document.getElementById("signOut");
      if (button) button.onclick = instance.signOut;
    }
  } else {
    setTimeout(_loadMainFrame, 5);
  }
}
// this is happening too late, many controls depend on pageManager being defined
// but pageManager is also a control...so it has to happen sometime after PageManager
// but before any dependencies...
// in a dialog scenario, it is happening too early, before the "menuAndView" frame
// fully loads (it has no content, no MenuForm defined yet).
// sounds like "pageManager" need to be a resource defined in a module.
window.onload = function() {
  return $(function() {
    return _loadMainFrame();
  });
};
var _ChildWindowList = new Array();
window.onunload = function() {
  OnClose(null, true);
};
function isModal() {
  var modal = false;
  if (window.dialogArguments) {
    if (typeof window.dialogArguments[0] == "string") {
      modal = true;
    }
  }
  return modal;
}
//
//Keep track of all child windows in case of unexpected exit from parent
//
function AddChildWindow(win, targetViewId) {
  _ChildWindowList.push(win);
}
//
// Attaches a windows as a child to the main Hansen 8 window
//
function AddChildWindowToMainFrame(win, targetViewId) {
  var main = win.parent.opener;
  while (main.parent != null && main.parent.opener != null) {
    main = main.parent.opener;
  }
  if (main != null && main._ChildWindowList) {
    main._ChildWindowList.push(win);
  } else {
    AddChildWindow(win, targetViewId);
  }
}
// ADS 26-May-2004 - Added flag to indicate if the window was closed through the system or outside the system
var _OutsideClose = true;
function SetInsideClose(targetViewId) {
  _OutsideClose = false;
}
///
///Close the window and child windows without going through cleanup code (KAI, CLRUSR)
///
function closeInternal(targetViewId) {
  SetInsideClose(targetViewId);
  closeChildren(targetViewId);
  //Reset the flag so the next request will cleanup
  _OutsideClose = true;
}
//
// Event fired when the window object is being unloaded.  Validate that applet instance's will
// be adequately handled and close
//
function OnClose(targetViewId, forceAll) {
  window.onload = null;
  closeChildren(targetViewId, forceAll);
  if (window.frames["cblock"] && window.frames["cblock"].Close) {
    window.frames["cblock"].Close(targetViewId, forceAll);
  }
  instance.modalDivContext = null;
  var g = window.Globalize();
  g.cultures = null;
  window.Globalize.prototype = null;
  window.Globalize = null;
  window.Slick.Grid = null;
  window.Slick = null;
  window.pageManager = null;
  window.tmpl = null;
  window.$.jstree.plugin = null;
  window.$.jstree._fn = null;
  window.$.jstree._instance = null;
  window.$.jstree = null;
  window.Print.destroy();
  window.Print = null;
  window.$ = null;
  if (window.cancelDiv) {
    window.cancelDiv.onclick = null;
    window.cancelDiv = null;
  }
}
///
///Called from the parent applet when the children need to be closed in an unexpected manner.
///The children should clean up their applet instances and close the window
///
function cleanCloseChild(targetViewId) {
  if (window.hasOpenModal == undefined || window.hasOpenModal == false) {
    //08/21/06 cpb - Russ added this to 804 to fix the modal closing problem
    closeChildren(targetViewId);
    window.onunload = null;
    window.frames["cblock"].closeWindow(targetViewId, true);
  }
}
///
///This method is called as an event handler for when the window's
///document is being unloaded.  It will send clear session and Kill Applet Instance
///requests to the server if needed.
function closeChildren(targetViewId, forceAll) {
  var i = 0;
  var done = false;
  var win;
  for (i = _ChildWindowList.length - 1; i >= 0; i--) {
    if (_ChildWindowList[i] && _ChildWindowList[i].closed) {
      var closedWindowArray = _ChildWindowList.splice(i, 1).pop();
    }
  }
  if (targetViewId == undefined) viewId = window.name;
  else viewId = targetViewId;
  while (_ChildWindowList.length > 0 && !done) {
    win = null;
    for (i = _ChildWindowList.length - 1; i >= 0; i--) {
      if (_ChildWindowList[i]) {
        var winVid = typeof _ChildWindowList[i] == "string" ? _ChildWindowList[i] : _ChildWindowList[i].name;
        if (winVid == viewId || forceAll) {
          win = _ChildWindowList.splice(i, 1).pop();
          break;
        }
      }
    }
    if (win == null) {
      done = true;
    }
    //	NOTE: Not sure if this is any better than window.close.
    //	TODO: Ensure any KAI events get to any "surviving" windows somehow.
    //	If the parent window is not the primary, then the session will have leaks.
    //RG 08-26-04 Notify the child windows that they must now close unexpectantly.  This causes cleanup code on the server to be executed.  The
    //previous code caused the child window to call back on the parent and caused the request queue to stack up.  Resulting in memory leak
    if (win && !win.closed) {
      //&& win.document.frames["view"].document.frames["viewTab"].OkayToClose )
      if (typeof win == "string") {
        instance.modalDivContext.winInstance.RemoveSpecificTask(win);
      } else {
        win.cleanCloseChild(viewId);
      }
    }
  }
  if (_OutsideClose) {
    var viewdoc = GetViewDocument(viewId);
    if (!viewdoc) return;
    var form = viewdoc.forms[0];
    //RG 06-03-04 Make sure the form exists.  On error from initial login page  no form is found
    if (form && form.getAttribute("apid")) {
      //09/18/06 cpb we should check for the applet id because we don't want 'undefined' to be sent in the request.
      var kai = "<KAI apid='" + form.getAttribute("apid") + "' monk='" + form.getAttribute("monk") + "'/>";
      // if && instance.opener.GetView is null then that means that the opener is NOT hansen8
      if (isChildWindow()) {
        // modeless
        // since this window is closing don't send the request through the closed window but go to the parent
        // and send the request through the parent.  targetViewID == undefined makes it use the CurrentView.
        // It is possible the parent window has already closed.  IE doesn't let you check this so try/catch is used.
        try {
          var parentInstance = instance.openers;
          if (parentInstance) parentInstance.sendCustomRequest(kai, undefined);
        } catch (s) {
          //Unable to reach the parent window.  It has likely closed
        }
      }
      if (instance.document.location.search.length > 0) {
        // modal child window
        if (window.returnValue == undefined || window.returnValue == null) window.returnValue = new Object();
        window.returnValue.cust = kai;
      } // modeless main view
      else {
        /* IE now prevents the postback on the CBlock form.  Indicated by an "access denied" error.
                We will now just send back the logout request as an ajax post
                //RG 08-26-04 Primary Hansen8 window was closed - Notify server that user's session should be cleared
                //DO not check request queue.  Just send the request.  Child windows can cause the parent request queueue to wait.
                //Window will close then regardless and cause a session memory leak
                var clr = "<CLRUSR clview='true' />";

              //Mark the window as unloading
                if( event != null && event.type == "unload" )
                windowUnloading = true;

              //if( window.frames["cblock"].send )
                //    window.frames["cblock"].send(clr, targetViewId);

                      */
        // Removed as it's unreliable to go back to the server when the browser is closed (window.unload)
        // if( viewdoc.forms.length > 0 )
        // {
        // window.iQuery.H8.callApplet("DefaultLogOffRule", null, viewdoc.forms[0], null);
        // viewdoc.forms[0].appBaseNode = null;
        // }
      }
    }
  }
}
// Event handlers
var _Events = new Array(); // List of event nodes
var _ABNodes; // List of applet base nodes
var _Data; // List of data nodes by component
var _DataID; // List of component names
var _Prefs = null; // List of client preference values
var _Ready = false; // false=CBlock currently on round-trip (or pending), true=no round-trip
var _PendingRequestDataChange = false; //A request has been sent that may effect the forms data.  Prevent validation from other requests
var _PendingRequestCancelEvents = false; //A request has been sent that must complete before other events occur.  Cancel additional events
var _PendingRequestQueue = []; //Queue of any events that need to trigger after a pending request has returned
var _TabProc = true; // false = tab pane busy, true = tab pane ready
var _TabId = 0; // Next ID for tab pane
var _CustomReq = "";
var _WaitForView = false;
var _SendSilently = true; // whether the pending request should be done without giving the "processing" message.
var _SendClientData = false; // ADS 15-Jan-2004 - Added ability to send a standard request without client data
var _AppPath = ""; // root path of application
var _ClientPath; // = "";  ADS 29-Mar-2004 - Added central path storage
var _ImgPath; // Root path of images
var _DeepPagePath = false;
var _ShowValidationMessage = true;
var _contentManagerAccess = false;
// ADS 29-Dec-2003 - Added processing prompt customization feature
var _DefaultWaitPrompt = "infor_ajax-loader_32x32.gif";
var _WaitPrompt = _DefaultWaitPrompt;
var AppletIdToViewId = new Array();
//Number of seconds to wait before displaying the request timeout link
var _CancelRequestTimeoutSeconds = 20;
var _WaitMessageTimeoutMs = 10;
var AutoCompleteSettings = {};
var InforUserAnalyticsEnabled = false;
var InforUserAnalyticsBaseUrl = "";
var InforUserAnalyticsTrackingClient = null;
var InforUserAnalyticsApplicationTracker = null;
// Global Init - called only on initial load of frameset
startNewEvent();
//function clearlog( msg , targetViewId){ if( window.frames["cblock"] && window.frames["cblock"].clearlog ) window.frames["cblock"].clearlog( msg , targetViewId); }
function openModalChild(url, monk, apid, src, w, h, t, a, targetViewId) {
  return window.frames["cblock"]._openModalChild(url, monk, apid, src, w, h, t, a, targetViewId);
}
//////////////////////////////////////////////////////////////////////////////
// Server event methods
function SetAppPath(args) {
  var options = $.extend(true, {}, args);
  log(options);
  _AppPath = options.path;
  _DeepPagePath = options.deep;
  runtimeMode = options.runtimeMode;
  //locale = "ar-SA";
  // MT - 21-May-2204 (Localization)
  _Locale = options.locale.name;
  if (runtimeMode == "Development") {
    var previousLang = localStorage["lang"];
    if (previousLang) {
      _Locale = previousLang;
    }
  }
  _DateFormat = options.locale.date;
  _TimeFormat = options.locale.time;
  _PhoneFormat = options.locale.phone;
  _CurrencyDecimalSeparator = options.locale.currencyDecimalSeperator;
  _CurrencyGroupSeparator = options.locale.currencyGroupSeparator;
  _NumberDecimalSeparator = options.locale.numberDecimalSeparator;
  _NumberGroupSeparator = options.locale.numberGroupSeparator;
  _CurrencySymbol = options.locale.currencySymbol;
  _PingInterval = options.pingInterval;
  AutoCompleteSettings = options.autoCompleteSettings;
  // ADS - 29-Mar-2004 - Added client-side image caching support
  // ADS - 17-Jun-2004 - Changed from hard-coded path to server-specified path
  _ClientPath = options.aspnet_client;
  _ImgPath = common.combine(_ClientPath, "Images");
  _MaxRequestRetries = options.maxRequestRetries;
  InforUserAnalyticsEnabled = options.inforUserAnalyticsEnabled;
  InforUserAnalyticsBaseUrl = options.inforUserAnalyticsBaseUrl;
  //include the client script file if Message Publishing is enabled or if we are running inside Ming.le
  if (!instance.contextMessaging) {
    if (IsMingle() || options.isContextPublishingEnabled) {
      _loadContextMessagingScript();
    }
  }
  instance.easeOfUse = options.easeOfUse;
  instance.runTimeOptions = options;
  var banner = $("#announcementBanner");
  if (options.isSafeMode) {
    options.announcementBanner = resx.GetString("Frame", "safemode");
  }
  if (options.announcementBanner && !instance.isModalDiv) {
    banner.show();
    if (banner.html() != options.announcementBanner) {
      banner.html(options.announcementBanner);
    }
    if (IsMingle() || instance.easeOfUse.hideHeader) {
      instance.document.body.className = "showFullAnnouncement";
    }
  } else {
    banner.hide();
    if (IsMingle() || instance.easeOfUse.hideHeader) {
      instance.document.body.className = "";
    }
  }
  if (instance.easeOfUse.theme) {
    var cssNode = document.getElementById("themeCSS");
    if (cssNode) {
      var cssPath = common.combine(_ClientPath, instance.easeOfUse.theme + ".css");
      if (cssNode.getAttribute("href") != cssPath) {
        cssNode.setAttribute("href", cssPath);
        var jsNode = document.getElementById("themeJS");
        jsNode.setAttribute("src", common.combine(_ClientPath, instance.easeOfUse.theme + ".js"));
      }
    }
  }
  SystemEvents("SetAppPath", options.targetViewId).trigger();
}
/// This is expected to be called only when context publishing is enabled.
function _loadContextMessagingScript() {
  var contextMessagingScript = "Client/contextMessagingCombined.js";
  $.getScript(contextMessagingScript)
    .done(function(script, textStatus) {
      log(textStatus);
    })
    .fail(function(jqxhr, settings, exception) {
      log("getScript() failed for " + contextMessagingScript + ".  " + exception);
    });
  // Load agency script
  contextMessagingScript = "Client/ContextMessaging/AgencyContextMessaging.js";
  $.getScript(contextMessagingScript)
    .done(function(script, textStatus) {
      log(textStatus);
    })
    .fail(function(jqxhr, settings, exception) {
      log("getScript() failed for " + contextMessagingScript + ".  " + exception);
    });
}
//////////////////////////////////////////////////////////////////////////////
// Event request methods
// Sets the image file shown for the next round trip
function setWaitPrompt(file, targetViewId) {
  _WaitPrompt = file;
}
var _WaitMsgPending = null;
function showWaitMsg() {
  // show ids counterpart
  if ((instance.easeOfUse && instance.easeOfUse.useInforDesign) || 
  (instance.frameElement && instance.frameElement.easeOfUse && instance.frameElement.easeOfUse.useInforDesign))
  {
    if (IsMingle() && !instance.isModalDiv){
      // @ts-ignore
      window.frames["menuAndView"].idslib.showIDSWaitMsg();
      return;
    } else {
      // @ts-ignore
      idslib.showIDSWaitMsg();
      return;
    }
  }
  var overlay = $("#ClickBarrier");
  if (instance.isModalDiv) {
    overlay = instance.modalDivContext.control.find("#ClickBarrier");
  }
  if (overlay.length == 0) {
    instance.notifyUser(resx.GetString("Frame", "loading"));
    function showWaitMessageDelayed() {
      try {
        var doc = document;
        if (instance.isModalDiv) {
          doc = instance.modalDivContext.control[0].ownerDocument;
        }
        overlay = doc.createElement("DIV");
        overlay.className = "inforOverlay";
        overlay.id = "ClickBarrier";
        overlay.tabIndex = 0;
        var indicator = doc.createElement("DIV");
        indicator.className = "ipsLoadingOverlay inforBusyIndicator pill large";
        var waitMessage = doc.createElement("span");
        waitMessage.id = "_Wait_loading";
        $(waitMessage).html(resx.GetString("frame", "loading"));
        window.cancelDiv = doc.createElement("span");
        cancelDiv.id = "_Wait_manualCancel";
        cancelDiv.className = "cancelLink";
        cancelDiv.style.display = "none";
        $(cancelDiv).html(resx.GetString("frame", "cancel"));
        cancelDiv.onclick = function(e) {
          manualCancel();
        };
        indicator.appendChild(waitMessage);
        indicator.appendChild(cancelDiv);
        overlay.appendChild(indicator);
        if (instance.isModalDiv) {
          instance.modalDivContext.control.append(overlay);
        } else {
          document.body.appendChild(overlay);
        }
        //set focus to the overlay so the user can't use the hotkeys
        //save off the active element to set focus when we remove the overlay.
        if (GetView() && GetView().document) {
          //activeElement can give an unspecified error in IE.  Need to catch that.
          try {
            if (GetView().document.activeElement) instance.previousActiveElement = GetView().document.activeElement;
          } catch (e) {
            instance.previousActiveElement = null;
          }
        }
        overlay.focus();
        instance._WaitPrompt = _DefaultWaitPrompt;
        //PS 12-30-05 If processing takes to long a "Cancel Request" link will now appear
        if (showCancelThread) {
          clearTimeout(showCancelThread);
          showCancelThread = 0;
        }
        showCancelThread = setTimeout(showManualCancel, _CancelRequestTimeoutSeconds * 1000);
      } catch (e) {
        log("Unable to show the wait message. " + e, "error");
      } finally {
        _WaitMsgPending = null;
      }
    }
    _WaitMsgPending = setTimeout(showWaitMessageDelayed, _WaitMessageTimeoutMs);
  }
}
///
///Show the "Cancel Request" link for long
///processing requests
///
var showCancelThread = 0;
function showManualCancel() {
  var overlay = $("#ClickBarrier");
  if (instance.isModalDiv) {
    overlay = instance.modalDivContext.control.find("#ClickBarrier");
  }
  if (overlay.length > 0) {
    var manualCancel = document.getElementById("_Wait_manualCancel");
    if (instance.isModalDiv) {
      manualCancel = instance.modalDivContext.control.find("#_Wait_manualCancel");
    }
    if (manualCancel) {
      $(manualCancel).css("display", "");
      var loading = document.getElementById("_Wait_loading");
      if (instance.isModalDiv) {
        loading = instance.modalDivContext.control.find("#_Wait_loading");
      }
      if (loading) {
        $(loading).css("display", "none");
      }
    }
  }
  showCancelThread = 0;
}
///
///Event handler for mouse click on "Cancel Request" link.  Forces
///the finish of server request
///
function manualCancel(targetViewId) {
  instance.notifyUser(resx.GetString("Frame", "finishedloading"));
  var ok = true;
  try {
    // This statement causes an error if cblock failed to load
    window.frames["cblock"].document;
  } catch (s) {
    // There was an error.  CBlock is missing.
    ok = false;
    var frameset = instance.document.getElementsByName["CBlkAndView"][0];
    var i;
    for (i = frameset.childNodes.length - 1; i >= 0; i--) {
      if (frameset.childNodes[i].name && frameset.childNodes[i].name.toLowerCase() == "cblock") {
        break;
      }
    }
    alert(resx.GetString("Frame", "CommunicationError"));
  }
  if (ok) {
    finishViewLoad(targetViewId, true);
  }
}
function hideWaitMsg() {
  //for ids busy inficator
  if ((instance.easeOfUse &&instance.easeOfUse.useInforDesign) || 
  (instance.frameElement && instance.frameElement.easeOfUse && instance.frameElement.easeOfUse.useInforDesign)){
    if (IsMingle() && !instance.isModalDiv){
      // @ts-ignore
      instance.frames["menuAndView"].idslib.hideIDSWaitMsg();
    }
    else {
      if(instance.isModalDiv) {
        var indicatorExists = instance.modalDivContext.control.find("ids-loading-indicator");
        if (indicatorExists) {
            indicatorExists.remove();
        }
      } 
      else {
        var indicatorExists = $('ids-loading-indicator');
        if (indicatorExists) {
          indicatorExists.remove();
        }
      }
    }
  }
  _Ready = true;
  var overlay = $("#ClickBarrier");
  if (instance.isModalDiv) {
    overlay = instance.modalDivContext.control.find("#ClickBarrier");
  }
  if (overlay.length) {
    instance.notifyUser(resx.GetString("Frame", "finishedloading"));
    overlay.remove();
    //Set the focus back the the previous active element before we opened overlay
    if (instance.previousActiveElement) {
      var isBodyElem =
        instance.previousActiveElement.tagName && instance.previousActiveElement.tagName.toLowerCase() === "body";
      // don't focus body element to prevent issue with page scrolling to top after user closes a modal box.
      if (instance.previousActiveElement.focus && !isBodyElem) {
        instance.previousActiveElement.focus();
      }
      instance.previousActiveElement = null;
    }
  }
  if (window.cancelDiv) {
    window.cancelDiv.onclick = null;
    window.cancelDiv = null;
  }
  if (showCancelThread) {
    clearTimeout(showCancelThread);
    showCancelThread = 0;
  }
  if (_WaitMsgPending) {
    clearTimeout(_WaitMsgPending);
    _WaitMsgPending = null;
  }
}
function waitForView() {
  _WaitForView = true;
}
function _ClearExistingEventData() {
  _ABNodes = new Array();
  _Data = new Array();
  _DataID = new Array();
  // First data group has no component id
  _Data[0] = "";
  _DataID[0] = "";
}
// Clears the event lists and prepares for a fresh event list
function startNewEvent(targetViewId) {
  // Clear arrays of existing data
  _Events = new Array();
  _EventsHaveUserActivity = false;
  _ClearExistingEventData();
  _SendSilently = true;
}
// Finds the event manager node closest in scope to the given HTML node
// CAUTION:  THIS METHOD LEAKS MEMORY DUE TO A CIRCULAR REFERENCE ON APPBASENODE.  AppBaseNode needs to be cleaned up during the unloading of the
// document
function findEM(node, targetViewId) {
  // there are times when the node is actually the event manager we want (clicking on the close button in the first screen
  // in the workorder creation process).  Short circuting the rest of the code prevents a memory leak by not assigning appBaseNode
  if (node.getAttribute("monk")) return node;
  var em = node;
  //RG 12-03-04 Performance Enhancement: Begin saving pointer to correct event manager
  if (em.appBaseNode) em = em.appBaseNode;
  else {
    //Iterate through until appropriate applet id base is found
    while (em) {
      if (em.getAttribute && em.getAttribute("monk")) break;
      if (em.getAttribute && em.getAttribute("htcid"))
        em = em.ownerDocument.getElementsByName[em.getAttribute("htcid")][0];
      else em = em.parentNode;
    }
    if (!em)
      //alert( "Could not find an EM node containing "+node.id+"." );
      alert(resx.GetString("Frame", "EMError") + node.id + ".");
    else node.appBaseNode = em;
  }
  return em;
}
// Adds an event tag to the events list
function addEvent(app, mkr, fn, src, args, bSilently, targetViewId, pbFormula) {
  addEventExp(app, mkr, fn, src, args, true, bSilently, true, targetViewId, pbFormula);
}
function addEventEx(app, mkr, fn, src, args, multi, bSilently, targetViewId) {
  addEventExp(app, mkr, fn, src, args, multi, bSilently, true, targetViewId);
}
function addEventExp(app, mkr, fn, src, args, multi, bSilently, data, targetViewId, pbFormula) {
  //If waiting for another event to return, cancel
  if (_PendingRequestCancelEvents) {
    log("addEventExp PendingRequestCancelEvents skipping " + fn, "warning");
    return false;
  }
  if (!bSilently) _SendSilently = false;
  // ADS 15-Jan-2004 - Added ability to send a standard event without client data
  if (data) _SendClientData = true;
  var id;
  if (src && src.id) {
    id = src.getAttribute("clientId") ? src.getAttribute("clientId") : src.id;
  } else {
    id = src;
  }
  // Special case = Client-side rule
  if (fn.substr(0, 2) == "C:") {
    setTimeout(fn.substr(2) + '("' + id + '","' + args + '");', 100);
  } else if (fn.indexOf("SystemPopupSearch") >= 0 && src && src.getAttribute("cache")) {
    // generic popup bypass
    var path;
    if (_DeepPagePath) path = _AppPath + "Core/Search/GenericSystemSearch.aspx";
    else path = _AppPath + "GenericSystemSearch.aspx";
    window.frames["cblock"]._openModalChild(
      path,
      "Hansen.Search.SearchApplet",
      "",
      src,
      700,
      500,
      args || "Popup",
      null,
      targetViewId
    );
  } else if (_Events.length == 0 || multi) {
    var event = new Object();
    var evt = "<EVENT ";
    if (app) evt += "applet='" + app + "' ";
    if (mkr) evt += "moniker='" + mkr + "' ";
    if (fn) evt += "fn='" + fn + "' ";
    if (pbFormula) evt += "postbackformula='" + pbFormula + "' ";
    if (src) {
      if (src.id) {
        //var parentFrames = src.ownerDocument.parentWindow.window.parent.frames;
        //var viewTab = parentframes["viewTab"];
        if (src.ownerDocument.forms[0] && src.ownerDocument.forms[0].getAttribute("vid")) {
          event.vid = src.ownerDocument.forms[0].getAttribute("vid");
          var page = src.ownerDocument.location.pathname.substr(
            src.ownerDocument.location.pathname.lastIndexOf("/") + 1
          );
          evt += "src='" + id + "' vid='" + event.vid + "' page='" + page + "' ";
        } else {
          var doc = GetViewDocument(targetViewId);
          var form = doc.forms[0];
          if (doc && form) {
            var dloc = doc.location;
            var page = dloc.pathname.substr(dloc.pathname.lastIndexOf("/") + 1);
            event.vid = doc.forms[0].getAttribute("vid");
            evt += "src='" + id + "' vid='" + event.vid + "' page='" + page + "' ";
          }
        }
      } else if (src.length) {
        evt += "src='" + src + "' ";
        event.vid = GetViewDocument(targetViewId).forms[0].getAttribute("vid");
        //RG 04-14-09 Attempt to get the ViewID to pass back to the server
        if (event.vid) {
          evt += " vid='" + event.vid + "' ";
        }
      }
      AppletIdToViewId[app] = event.vid;
    }
    // we need to always have a view id on the event because an event without a vid
    // is not valid
    if (!event.vid) {
      event.vid = targetViewId;
      var view = GetView(targetViewId);
      if (view) {
        event.vid = view._currentViewId;
      }
      // we need to check to see if we need to add the vid to the event string
      if (evt.indexOf(" vid='") == -1 && event.vid) {
        evt += " vid='" + event.vid + "' ";
      }
    }
    if (args && args.length > 0) evt += ">" + args + "</EVENT>";
    else evt += "/>";
    event.text = evt;
    _Events.push(event);
  }
  return true;
}
function getDataIndex(comp, targetViewId) {
  var idx = 0;
  if (_DataID.length == 0) _DataID.push("");
  if (comp && comp.child) {
    if (comp.bind && comp.bind.substring(0, 1) == "[") {
      var bind = comp.bind.substring(comp.bind.indexOf("]") + 1);
      var apid = comp.bind.substring(1, comp.bind.indexOf(","));
      var cid = bind + "_" + apid;
      for (var i = 0; i < _DataID.length; i++) {
        if (_DataID[i] == cid) {
          idx = i;
          break;
        }
      }
      if (idx == 0) {
        _DataID.push(cid);
        idx = _DataID.length - 1;
        _Data[idx] = "<COMP id='" + bind + "' apid='" + apid + "' ";
        // Locate a moniker for this component
        var ccl = GetViewDocument(targetViewId).getElementById["__MONK_LIST__"];
        if (ccl) {
          for (var i = 0; i < ccl.children.length; i++) {
            if (ccl.children[i].name == comp.bind) {
              _Data[idx] += "moniker='" + ccl.children[i].getAttribute("monk") + "' ";
              break;
            }
          }
        }
        _Data[idx] += ">";
      }
    } else {
      var appBase = findEM(comp.child, targetViewId);
      if (appBase) {
        //RG 12-06-04 Make sure this EM has been added to the base applet list
        //Needed due to new method of obtaining client controls through getElementByTagName call
        if (appBase.getAttribute("apid")) {
          if (_ABNodes[appBase.getAttribute("apid")] == undefined)
            _ABNodes[appBase.getAttribute("apid")] =
              "<NODE id='" +
              appBase.id +
              "' apid='" +
              appBase.getAttribute("apid") +
              "' monk='" +
              appBase.getAttribute("monk") +
              "'/>";
        }
        if (comp.bind) {
          var cid = comp.bind + "_" + appBase.getAttribute("apid");
          for (var i = 0; i < _DataID.length; i++) {
            if (_DataID[i] == cid) {
              idx = i;
              break;
            }
          }
          if (idx == 0) {
            _DataID.push(cid);
            idx = _DataID.length - 1;
            _Data[idx] = "<COMP id='" + comp.bind + "' apid='" + appBase.getAttribute("apid") + "' ";
            // Locate a moniker for this component
            var ccl = GetViewDocument(targetViewId).getElementById("__MONK_LIST__");
            if (ccl) {
              for (var i = 0; i < ccl.children.length; i++) {
                if (ccl.children[i].name == comp.bind) {
                  _Data[idx] += "moniker='" + ccl.children[i].getAttribute("monk") + "' ";
                  break;
                }
              }
            }
            _Data[idx] += ">";
          }
        }
      }
    }
  }
  return idx;
}
function addDownloadOnlyData(comp, name, dest, type, monk, targetViewId) {
  if (name != null && name.length > 0) {
    var idx = getDataIndex(comp, targetViewId);
    _Data[idx] += "<DOWNLOADONLYITEM name='" + name + "' ";
    if (dest) _Data[idx] += "dest='" + dest + "' ";
    if (monk) _Data[idx] += "monk='" + monk + "' ";
    if (type && type != null && type.length > 0) _Data[idx] += "type='" + type + "' ";
    _Data[idx] += "/>";
  }
}
// Adds a data tag to the correct group in the data lists
function addAttachments(comp, name, val, monk, imagetype, bind, keytype, node, targetViewId) {
  var ctrl = node;
  var appid = null;
  if (ctrl.length) {
    //alert("Warning: More than one node with id=\""+id+"\" was found.");
    alert(resx.GetString("Frame", "MultipleNodeWarning") + id + '".');
    ctrl = ctrl[0];
  }
  if (ctrl) {
    // Get the EventManager for this control
    var em = findEM(ctrl, targetViewId);
    // Retrieve the moniker and appid
    if (em) appid = em.getAttribute("apid");
  }
  if (name != null && name.length > 0 && val != null) {
    var idx = getDataIndex(comp, targetViewId);
    _Data[idx] += "<ITEM name='" + xmlEscape(name) + "' val='" + xmlEscape(val) + "' ";
    _Data[idx] += "isAttachments='true' ";
    if (monk) _Data[idx] += "monk='" + monk + "' ";
    //these are required fields so they better be there
    _Data[idx] += "imagetype='" + imagetype + "' ";
    _Data[idx] += "appid='" + appid + "' ";
    _Data[idx] += "bind='" + bind + "' ";
    _Data[idx] += "keytype='" + keytype + "' ";
    _Data[idx] += "/>";
  }
}
///
///Add a specific control and its value to the data list
///
function addControlData($control, value, targetViewId) {
  //Get the controls binding information
  var comp = collectBindData($control, targetViewId);
  //Add as generic item tag
  addData(comp, $control.options.id, value, comp.dest, comp.dataType, comp.monk, targetViewId);
}
// Adds a data tag to the correct group in the data lists
function addData(comp, name, val, dest, type, monk, targetViewId) {
  if (name != null && name.length > 0 && val != null) {
    var idx = getDataIndex(comp, targetViewId);
    var tempData = new Array();
    tempData.push(_Data[idx]);
    tempData.push("<ITEM name='");
    tempData.push(xmlEscape(name));
    tempData.push("' val='");
    tempData.push(xmlEscape(val));
    tempData.push("' ");
    if (dest) {
      tempData.push("dest='");
      tempData.push(dest);
      tempData.push("' ");
    }
    if (monk) {
      tempData.push("monk='");
      tempData.push(monk);
      tempData.push("' ");
    }
    if (type && type != null && type.length > 0) {
      tempData.push("type='");
      tempData.push(type);
      tempData.push("' ");
    }
    tempData.push("/>");
    _Data[idx] = tempData.join("");
  }
}
function addGrid(comp, name, dest, data, monk, targetViewId) {
  if (data != null && data.length > 0) {
    var idx = getDataIndex(comp, targetViewId);
    _Data[idx] += data;
  }
}
function addFileUpload(comp, name, dest, data, monk, targetViewId) {
  if (data != null && data.length > 0) {
    var idx = getDataIndex(comp, targetViewId);
    _Data[idx] += data;
  }
}
//PC 10/7/07 - Add the current tab to be used for GetControlValue method
function addTabPane(id, currentTab, targetViewId) {
  var idx = getDataIndex(null, targetViewId);
  //trim the string
  currentTab = currentTab.replace(/^\s+|\s+$/g, "");
  if (!containsTabPane(id, currentTab, targetViewId))
    _Data[idx] += "<TABPANE id='" + id + "' currentTab='" + currentTab + "'/>";
}
// checks to see if the _Data array already contains this tab
function containsTabPane(id, currentTab, targetViewId) {
  for (var i in _Data) {
    var item = _Data[i];
    var tabPane = "<TABPANE id='" + id + "'";
    if (item && item.match(tabPane + "+?") == tabPane) {
      return true;
    }
  }
  return false;
}
///
///Add a search range control data for server postback
///
function addSearchRange(name, control, targetViewId, view) {
  var idx, Nodes, child, comp, dest, datatype, monk;
  if (name != null && name.length > 0) {
    idx = getDataIndex(null, targetViewId);
    _Data[idx] += "<SEARCHRANGE type='Hansen.UI.Web.Controls.SearchRange' name='" + name + "'>";
    var Nodes = [
      view.getControl(control.options.textBoxes[0].id, "ipsTextbox"),
      view.getControl(control.options.textBoxes[1].id, "ipsTextbox")
    ];
    for (var i = 0; i < Nodes.length; i++) {
      // Get the bind information
      child = Nodes[i];
      comp = "";
      dest = "";
      if (child.options.bind) dest = child.options.bind;
      datatype = "";
      if (child.options.dataType) datatype = child.options.dataType;
      monk = "";
      if (child.options.moniker) monk = child.options.moniker;
      _Data[idx] +=
        "<ITEM name='" +
        xmlEscape(child.options.id) +
        "' val='" +
        xmlEscape(child.getControlValue()) +
        "' op=' " +
        xmlEscape(child.options.rangeOperation) +
        "' ";
      if (dest) _Data[idx] += "dest='" + dest + "' ";
      if (monk) _Data[idx] += "monk='" + monk + "' ";
      if (datatype) _Data[idx] += "type='" + datatype + "' ";
      if (child.options.formatType)_Data[idx] += "formatType='" + child.options.formatType + "' ";
  
      _Data[idx] += "/>";
      // GaryW 5-14-2012 SC#70258
      // Now that Hansen8 supports TransientComponent that allow all lookup fields to be bound
      // EditBox from within a SearchRange should be added to the Data list for Component binding ( so data will be set to component ).
      //HPS-68401 GaryW - We need to add the data to the <COMP> list only if there is binding information
      // calling addControlData without binding information will cause duplciates
      //var comp = collectBindData(Nodes[i].element[0], targetViewId);
      //if ( comp && comp.bind && comp.dest)  // checking for binding information
      //	addControlData(Nodes[i], Nodes[i].TextValue, targetViewId);
    }
    //close control
    _Data[idx] += "</SEARCHRANGE>";
  }
}
// Will find the appropriate control and set its value.
function setControlValue(id, val, targetViewId) {
  try {
    setControlValueDoc(id, val, GetViewDocument(targetViewId), targetViewId);
  } catch (e) {
    log("Unable to set value for control " + id + ".  " + e);
  }
}
function setControlValueDoc(id, val, doc, targetViewId) {
  if (id != null && id.length > 0 && val != null) {
    //get the control
    var ctrl = GetControl(id, doc, targetViewId);
    if (!ctrl && id.indexOf("!") > -1) {
      // ADS 11-Feb-2005 - Ensure there is no closed recursion by sending the undecorated control id to the parent
      var parentId = id.substr(0, id.indexOf("!"));
      id = id.substr(id.indexOf("!") + 1);
      ctrl = GetControl(parentId, doc, targetViewId);
    }
    if (ctrl != null) {
      if (ctrl.setControlValue) {
        ctrl.setControlValue(val, id);
      }
    }
  }
}
//supported types:
// "bool"
function convertToType(value, type) {
  switch (type) {
    case "bool":
      var stringVal = String(value);
      switch (stringVal.toLowerCase()) {
        case "true":
          return true;
        case "false":
          return false;
        case "1":
          return true;
        case "0":
          return false;
      }
      break;
  }
  return value;
}
// Will find the appropriate on acontrol and set an attribute on its node.
function setControlAttribute(id, att, val, targetViewId) {
  if (id != null && id.length > 0 && val != null && val.length > 0) {
    var view = GetView(targetViewId);
    //get the control
    var ctrl = view.getControl(id);
    if (ctrl != null) {
      att = capitaliseFirstLetter(att.toLowerCase());
      var setAttributeName = "set" + att;
      if (ctrl[setAttributeName]) {
        ctrl[setAttributeName](val);
      } else {
        log("The control " + id + " does not have the public function " + setAttributeName, "error");
      }
    }
  }
}
//http://stackoverflow.com/questions/1026069/capitalize-the-first-letter-of-string-in-javascript
function capitaliseFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}
// Changes a style attribute on a control
function setControlStyle(id, style, val, targetViewId) {
  if (id != null && id.length > 0 && val != null && val.length > 0) {
    //get the control
    var view = GetView(targetViewId);
    var node = view.document.getElementById(id);
    if (node != null) {
      var control = view.getControl(id);
      if (control && control.setControlStyle) {
        control.setControlStyle(style, val);
      } else {
        node.style[style] = val;
      }
    }
  }
}
function _orderControlList(controls) {
  var keyControls = [];
  var idControls = [];
  var regularControls = [];
  for (var id in controls) {
    var control = controls[id];
    if (control) {
      if (control.options.isPrimaryKey) {
        keyControls.push(control);
      } else if (control.options.isIdentity) {
        idControls.push(control);
      } else {
        regularControls.push(control);
      }
    }
  }
  // key controls shoudl be first, followed by id controls followed by regular controls
  return keyControls.concat(idControls).concat(regularControls);
}
// goes through the list of types and does a "addControlData" for each control
function _addControlData(listOfTypes, targetViewId, controlCache) {
  listOfTypes.forEach(function(type) {
    if (!controlCache[type]) return;
    _orderControlList(controlCache[type]).forEach(function(control) {
      // simple controls do NOT need to implement their own function to add the state to the request
      // Complex controls do!
      if (typeof control.addStateToRequest === "function") {
        control.addStateToRequest();
      } else if (typeof control.getControlValue === "function") {
        addControlData(control, control.getControlValue(), targetViewId);
      }
    });
  });
}
///
///Creates xml data list of Hansen control's current view state
///Data is retrieved off current view DOM
///
function collectChildData(viewDoc, targetViewId) {
  function filterOutSuppressedValues(list, targetViewId) {
    var suppressPropertyName = "suppressValuePostBack";
    var newList = [];
    for (var i = 0; i < list.length; i++) {
      if (!list[i][suppressPropertyName]) {
        newList.push(list[i]);
      }
    }
    return newList;
  }
  //counter for control arrays
  var i = 0;
  //Search the DOM for each Hansen control type
  //RG 01-13-05 Don't post back values marked as inner controls
  var suppressPropertyName = "suppressValuePostBack";
  var view = GetView(targetViewId);
  var controlsOnPage = view.controlsOnPage;
  var controlCache = view.controlCache;
  SystemEvents("collectChildData", targetViewId).trigger(view, controlCache);
  let whitelist = [
    "ipsTextbox",
    "ipsCheckBox",
    "ipsTree",
    "ipsDataGrid",
    "ipsCodeEditor",
    "ipsDropDownbox",
    "ipsRadioButtonArray",
    "ipsRadioButton",
    "ipsAttachment",
    "ipsRichTextEditor",
    "ipsSearchRange",
    "ipsTabset",
    "ipsLabel",
    "ipsColorPicker",
    "ipsMap",
    "ipsMonthlyCalendar",
    "ipsTreeGrid",
    "ipsProgressBar",
    "ipsFileUpload",
    "idsTextbox",
    "idswizard"
  ];
  _addControlData(whitelist, targetViewId, controlCache);
  if (controlsOnPage & 512) {
    //Calendar controls
    var calendarControls = viewDoc.getElementsByTagName("CALENDAR");
    for (i = 0; i < calendarControls.length; i++) {
      if (!calendarControls[i][suppressPropertyName])
        addControlData(
          calendarControls[i],
          calendarControls[i].value.getMonth() +
            1 +
            "/" +
            calendarControls[i].value.getDate() +
            "/" +
            calendarControls[i].value.getFullYear(),
          targetViewId
        );
    }
  }
  //SearchRange
  var inputControls = viewDoc.getElementsByTagName("INPUT");
  for (i = 0; i < inputControls.length; i++) {
	var suppressValue = inputControls[i][suppressPropertyName] || inputControls[i].getAttribute(suppressPropertyName);
    if (!suppressValue) {
      if (inputControls[i].type.toLowerCase() == "file") {
        addControlData(inputControls[i], inputControls[i].value, targetViewId);
      }
    }
  }
}
//
//Collect bind and datatype information from the Hansen control node
//
function collectBindData($node) {
  //Object list of component bind information
  var comp = {};
  comp.child = $node.element && $node.element[0];
  //If control has bind then parse the information
  var bind = $node.options.bind;
  if (bind) {
    var brkt = bind.indexOf("]");
    if (brkt > -1) {
      // Handle parent binding case
      comp.bind = bind;
      var pt = bind.indexOf(".", brkt);
      if (pt > -1) {
        comp.bind = bind.substring(0, pt);
        comp.dest = bind.substring(pt + 1, bind.length);
      }
    } else {
      //Parse bind information
      comp.bind = bind;
      var pt = bind.indexOf(".");
      if (pt > -1) {
        comp.bind = bind.substring(0, pt);
        comp.dest = bind.substring(pt + 1, bind.length);
      }
    }
  }
  var moniker = $node.options.moniker;
  if (moniker) comp.monk = moniker;
  var dataType = $node.options.dataType;
  if (dataType) comp.dataType = dataType;
  return comp;
}
// Builds data lists for all recognized nodes on the view form
function buildDataList(targetViewId) {
  var viewdoc = GetViewDocument(targetViewId);
  if (viewdoc && viewdoc.forms[0]) collectChildData(viewdoc, targetViewId);
}
// gets a list of events that are from the same view
function _getEventsPerView(events) {
  var list = new Array();
  for (let key in events) {
    var vid = events[key].vid;
    if (list[vid] == undefined) {
      list[vid] = new Object();
      list[vid].text = events[key].text;
      list[vid].vid = vid;
    } else {
      list[vid].text += events[key].text;
    }
  }
  return list;
}
// Finishes the event XML and fires a round-trip on the CBlock
function sendEvents(callerOnly, id, targetViewId) {
  if (_Events.length > 0) {
    var viewDoc = GetViewDocument(targetViewId);
    //Ensure the view is loaded
    if (!viewDoc || !viewDoc.body) {
      log("view is not ready yet", "warning");
      setTimeout(function waitForView() {
        sendEvents(callerOnly, id, targetViewId);
      }, 100);
      return;
    }
    var eventList = _getEventsPerView(_Events);
    var hasUserActivity = _EventsHaveUserActivity;
    _PostbackHasUserActivity = hasUserActivity;
    var req = new Array();
    if (hasUserActivity) {
      req.push("<REQUEST>");
    } else {
      // This request should not update the timeout period for user activity.
      req.push("<REQUEST userActivity='false' >");
    }
    _Ready = false;
    _TabProc = false; // ADS 23-July-03 - Mark tab pane as busy as well
    _WaitForView = false;
    if (!_SendSilently) showWaitMsg(null); // only show the processing message on the current view
    for (let vid in eventList) {
      window.vid = vid;
      // ADS 15-Jan-2004 - Added ability to send a standard event without client data
      if (_SendClientData) {
        buildDataList(vid);
      }
      // Build XML
      req.push("<EVENTS>");
      req.push("<DATA>");
      req.push(_Data[0]);
      req.push(GetGlobalData(viewDoc));
      for (var i = 1; i < _Data.length; i++) {
        req.push(_Data[i]);
        req.push("</COMP>");
      }
      req.push("</DATA>");
      if (_Prefs != null) {
        req.push("<PREFS>");
        for (var ctrl in _Prefs) {
          req.push("<PREF id='");
          req.push(ctrl);
          req.push("' ");
          req.push(_Prefs[ctrl]);
          req.push(" />");
        }
        req.push("</PREFS>");
        _Prefs = null;
      }
      //RG 12-06-04 _ABNodes Items now stored in hashtable.  Iterate through adding each applet base
      req.push("<BASES>");
      for (let key in _ABNodes) {
        req.push(_ABNodes[key]);
      }
      req.push("</BASES>");
      //Only add those events for this vid
      req.push(eventList[vid].text);
      req.push("</EVENTS>");
      _ClearExistingEventData();
    }
    // ADS 15-Jan-2004 - Added ability to send a standard event without client data
    if (_SendClientData) {
      _SendClientData = false;
    }
    req.push("</REQUEST>");
    log(req);
    startNewEvent(); // Clear event list for new entries
    var e = SystemEvents("sendEvents", targetViewId).trigger(req);
    if (e.result) {
      sendRequest(req, targetViewId, hasUserActivity);
    }
  }
}
/**
 * @param hasUserActivity true iff the request is considered user activity for the purposes of inactivity warning.
 */
function sendRequest(req, targetViewId, hasUserActivity) {
  if (
    window.frames["cblock"] &&
    window.frames["cblock"].send &&
    window.frames["cblock"].document.readyState == "complete"
  ) {
    window.frames["cblock"].send(req.join(""), targetViewId); // Send request
    // Do not reset the ping thread if there is no user activity.
    if (hasUserActivity) {
      stopMaintainSessionTimerThread(targetViewId);
    }
  } else {
    setTimeout(function() {
      sendRequest(req, targetViewId, hasUserActivity);
    }, 100);
  }
}
function isViewReady(targetViewId) {
  return GetViewDocument(targetViewId) != null;
}
function isMenuReady() {
  //Is the menu/view frame present and ready
  return instance.frames["menuAndView"].document && instance.frames["menuAndView"].document.readyState == "complete";
}
function GetGlobalData(viewDoc) {
  var retval =
    '<PAGEPROP name="ViewWidth" value="' +
    viewDoc.body.clientWidth +
    '" />' +
    '<PAGEPROP name="ViewHeight" value="' +
    viewDoc.body.clientHeight +
    '" />' +
    '<PAGEPROP name="WindowWidth" value="' +
    document.body.clientWidth +
    '" />' +
    '<PAGEPROP name="WindowHeight" value="' +
    document.body.clientHeight +
    '" />';
  if (viewDoc.forms && viewDoc.forms.length > 0) {
    var isClean =
      viewDoc.forms[0].getAttribute("isClean") == undefined ? "true" : viewDoc.forms[0].getAttribute("isClean");
    var chkClean =
      viewDoc.forms[0].getAttribute("chkClean") == undefined ? "true" : viewDoc.forms[0].getAttribute("chkClean");
    retval +=
      '<PAGEPROP name="IsClean" value="' +
      isClean +
      '" />' +
      '<PAGEPROP name="IsPageStateValidated" value="' +
      chkClean +
      '" />';
  }
  return retval;
}
// Sends a custom-build request to the server
function sendCustomRequest(req, targetViewId, wait) {
  if (_Ready) {
    _Ready = false;
    _WaitForView = false;
    instance.frames["cblock"].send(req, targetViewId); // Send request
    if (!_SendSilently || wait) showWaitMsg(targetViewId);
  } else {
    if (_CustomReq.length > 0) _CustomReq += req;
    else _CustomReq = req;
  }
}
// Used when an item is added to the event queue to ensure that,
// sooner or later, the events are sent to the server
/**
 * @param isUserActivity true or null if the event is considered "user activity" for the purposes of inactivity timeout.
 * @param runImmediately true if the call is to be sent immediately, otherwise will perform normal 100ms set timeout
 */
function eventAdded(targetViewId, isUserActivity, runImmediately) {
  if (isUserActivity == null) isUserActivity = true;
  _EventsHaveUserActivity = _EventsHaveUserActivity || isUserActivity;
  // Only send if there is something waiting to go out
  if (_Events.length > 0) {
    // If we're not sending, set a timer to send in a little bit
    if (_Ready) {
      log("Queue ready to send");
      _Ready = false;
      _TabProc = false; // ADS 23-July-03 - Mark tab pane as busy as well
      if (runImmediately) {        
        sendEvents(false, null, targetViewId);
      }
      else {
        setTimeout(function () {
          sendEvents(false, null, targetViewId);
        }, 100);
      }

    }
  }
}
// ENTRY-POINT: Client controls sending an event through the
// system do so by calling this function
// fn: the applet method name.
// id: the id of the control that fired the event.
// appletMoniker: the moniker of the applet.  If not supplied, the containing event manager is used.
function queueEvent(fn, id, appletMoniker, args, bSilently, targetViewId, pendingRequestCancelEvents, pbFormula) {
  log("Queueing event ( " + fn + ", " + id + ", " + appletMoniker + " , " + targetViewId + ")");
  // Find control
  // First chance, straight in the view
  var view = GetView(targetViewId);
  var viewDoc = GetViewDocument(targetViewId);
  var ctrl = viewDoc.getElementById(id);
  var em = null;
  // Second chance, remove suffix decoration
  if (!ctrl) {
    if (id.indexOf("!") > -1) ctrl = viewDoc.getElementById(id.substr(0, id.indexOf("!")));
  }
  // Third chance, look in the navi bar
  if (!ctrl) {
    var navi = GetNaviBar(targetViewId);
    var owner = navi.element[0].ownerDocument;
    if (IsDialog(targetViewId)) {
      ctrl = owner.getElementById(id);
    } else {
      ctrl = owner.getElementById(id);
    }
    em = findEM(viewDoc.forms[0], targetViewId);
  }
  queueEventObj(fn, ctrl, appletMoniker, args, em, bSilently, targetViewId, pendingRequestCancelEvents, undefined, undefined, pbFormula);
}
/**
 * @param isUserActivity true or null if the event is considered "user activity" for the purposes of inactivity timeout.
 * @param runImmediately true if the call is to be sent immediately, otherwise will perform normal 100ms set timeout
 */
function queueEventObj(
  fn,
  ctrl,
  appletMoniker,
  args,
  em,
  bSilently,
  targetViewId,
  pendingRequestCancelEvents,
  isUserActivity,
  runImmediately,
  pbFormula
) {
  if (ctrl && ctrl.length) {
    //alert("Warning: More than one node with id=\""+ctrl.id+"\" was found.");
    if (1 < ctrl.length) alert(resx.GetString("Frame", "MultipleNodeWarning") + '".');
    ctrl = ctrl[0];
  }
  var moniker = appletMoniker;
  var appid = null;
  if (!moniker) {
    // Get the EventManager for this control
    if (em == null) em = findEM(ctrl, targetViewId);
    // Retrieve the moniker and appid
    if (em) {
      moniker = em.getAttribute("monk");
      appid = em.getAttribute("apid");
    }
  }
  // Put event on the events list
  if (args) addEvent(appid, moniker, fn, ctrl, args, bSilently, targetViewId, pbFormula, isUserActivity);
  else addEvent(appid, moniker, fn, ctrl, null, bSilently, targetViewId, pbFormula, isUserActivity);
  eventAdded(targetViewId, isUserActivity, runImmediately);
  if (pendingRequestCancelEvents === true) {
    //if we are firing a server event that could change the page, we don't want any other events occuring until we return
    _PendingRequestCancelEvents = true;
  }
}
function RemoveModuleMenuOptions(targetViewId) {
  var success = false;
  var menuForm = getMenuForm();
  if (menuForm && menuForm.RemoveModuleMenuOptionsInHeader) {
    menuForm.RemoveModuleMenuOptionsInHeader(targetViewId);
  }
  return success;
}
function AddModuleMenuOptions(targetViewId) {
  var success = false;
  var menuForm = getMenuForm();
  if (menuForm) {
    menuForm.AddModuleMenuOptionsInHeader(targetViewId);
  }
  return success;
}
// shows the Jump to form so they can navigate to a form using codes
function jumpToFormCodes() {
  var menuForm = getMenuForm();
  if (menuForm) {
    menuForm.showJumpToForm();
  }
  return false;
}
function showOrHideTabPreview() {
  var menuForm = getMenuForm();
  if (menuForm) {
    menuForm.showOrHide();
  }
}
function hideSignOutButton() {
  var button = $(".signOut");
  if (button) button.hide();
}
function getMenuForm() {
  return window.frames["menuAndView"];
}
function finishViewLoad(targetViewId, manualCancel) {
  var myTitle = GetHeaderTitle(targetViewId);
  finishViewLoadWithHeaderTitle(myTitle, targetViewId, manualCancel);
}
// Last function called by CBlock load
function finishViewLoadWithHeaderTitle(headerTitle, targetViewId, manualCancel) {
  var isReady = isViewReady(targetViewId);
  if (!isReady) {
    log("view is not ready yet", "warning");
    setTimeout(function waitForView() {
      finishViewLoadWithHeaderTitle(headerTitle, targetViewId);
    }, 100);
    return;
  }
  //Handle pending requests for data changing or canceling other events
  _PendingRequestCancelEvents = false;
  if (_PendingRequestDataChange) {
    //flag for other requests where data may be changing
    _PendingRequestDataChange = false;
    //If any requests have queued up, execute them now
    while (_PendingRequestQueue.length > 0) _PendingRequestQueue.pop()();
    _PendingRequestQueue = [];
  }
  // If there are more events, send them off
  if (_Events.length > 0) {
    setTimeout(function() {
      sendEvents(false, null, targetViewId);
    }, 100);
  } else if (_CustomReq.length > 0) {
    window.frames["cblock"].send(_CustomReq, targetViewId);
    _CustomReq = "";
  } // Done sending events, rest
  else {
    _TabProc = true; // ADS 23-Jul-03 - Mark tab pane as ready as well
    if (!_WaitForView || manualCancel) hideWaitMsg(targetViewId);
  }
  // Do not reset the ping thread if there is no user activity associated with this reload.
  if (_PostbackHasUserActivity == null || _PostbackHasUserActivity) {
    startMaintainSessionTimerThread(targetViewId);
  }
  _PostbackHasUserActivity = null;
  //RG 04-26-04 Set body's tab index to negative value so focus will not be set on it
  var viewDoc = GetViewDocument(targetViewId);
  if (viewDoc && viewDoc.body) {
    viewDoc.body.tabIndex = -1;
    if (!viewDoc.getAttribute && viewDoc.documentElement) {
      viewDoc = viewDoc.documentElement;
    }
	
    // So titles get set on CallChildApplet windows.
    try {
      if (
        isChildWindow() &&
        viewDoc.getAttribute("title") &&
        viewDoc.getAttribute("title").length > 0 &&
        window.opener.GetView
      ) {
        if (headerTitle != null && headerTitle != "") {
          viewDoc.setAttribute("title", headerTitle);
          window.frames["menuAndView"].updateModuleHeader(headerTitle, undefined, targetViewId);
        } else {
          if (headerTitle != undefined) {
            viewDoc.setAttribute("title", viewDoc.getAttribute("title"));
            window.frames["menuAndView"].updateModuleHeader(viewDoc.getAttribute("title"), undefined, targetViewId);
          }
        }
      }
	  
    } catch (err) {
      //IE will die if you touch instance.opener.top and the parent window is closed.  There is no way
      //To check without an exception
      log("Error when finishing the view.", "error");
      log(err, "error");
    }
  }
  SystemEvents("requestFinished", targetViewId).trigger(viewDoc);
}
// Last function called by View
function finishView(view, ctrlid, dev, targetViewId) {
  finishViewWithHeaderTitle(view, ctrlid, dev, "", targetViewId);
}
function finishViewWithHeaderTitle(view, ctrlid, dev, headerTitle, targetViewId) {
  viewReadyStateWithHeaderTitle(view, ctrlid, dev, headerTitle, targetViewId);
}
function viewReadyState(view, ctrlid, dev, targetViewId) {
  viewReadyStateWithHeaderTitle(view, ctrlid, dev, "", targetViewId);
}
// View complete event handler
function viewReadyStateWithHeaderTitle(view, ctrlid, dev, headerTitle, targetViewId, isInitialPageLoad) {
  view.updateControlSize();
  view.removeClickBarrier(targetViewId);
  finishViewLoadWithHeaderTitle(headerTitle, targetViewId);
  // Only set focus if the control is found and the view is still the current view
  var focusOnFirstControl = view == GetView(targetViewId);
  // ADS - 29-Jan-2004 - Added an extra state to make control arranging wait until after the view is done
  if (!view.IsArrangeAllowed()) view.AllowArrange(true);
  if (view.skipFirstControlFocus == undefined || view.skipFirstControlFocus == false) {
  if (ctrlid && ctrlid.length > 0 && focusOnFirstControl) {
      var ctrl = GetControl(ctrlid, view.document, targetViewId);
      if (ctrl && !view.parentIsHidden(ctrl)) {
        if (view.setControlFocus(ctrl)) {
          focusOnFirstControl = false;
          }
		}
	  }
    if (focusOnFirstControl && isInitialPageLoad) {
      var control = view.findFirstControl();
      if (control) {
        control.focus();
      }
    }
	// HPS-112197 Better to place the call here for scrolling up than IPSTabset.js for less timeout time since all of the components 
	// at this point have been loaded only the resizing will be done afterwards
	view.forceScrollToTopOfPage();
  }
}
// Opens an info viewer for the given component key
function zoom(monk, key, type, src, targetViewId) {
  zoomEx(monk, key, type, src, null, targetViewId);
}
// Opens an info viewer for the given component key, providing a callback delegate for the viewer close event
function zoomEx(monk, key, type, src, delegate, targetViewId) {
  var param = "";
  var method = "InitViewZoom";
  
	var papid = "";
	var pmonk = "";
	var apBase;
	
	if (src && src.getAttribute)
	{
		apBase = findEM(src, targetViewId);
	}
	else
	{
		apBase = findEM(GetView(targetViewId).document.forms[0], targetViewId);
	}
	if (apBase) 
	{
	  papid = apBase.getAttribute("apid");
	  pmonk = apBase.getAttribute("monk");
	}
  
  if (delegate != null && delegate.length > 0) 
  {    
    param += "<PARAM val='" + papid + "'/><PARAM val='" + pmonk + "'/><PARAM val='" + delegate + "'/>";
    method = "InitViewDelegateZoom";
  }
  
  if (type != "null") 
  {
	  param += "<PARAM val='" + xmlEscape(key) + "' type='" + type + "'/>";
  }
  
  param = "<PARAM val='" + monk + "'/>" + param;
  
  // Publish a shortcut message to enable the "favorite" icon for this applet
  if (!key && instance.contextMessaging) 
  {
    // WARNING: moniker is not defined anywhere
    var areaArray = moniker.split(";");
    var area = areaArray[areaArray.length - 1];
    // Add a space before each capital letter
    // The targetViewId may be always be provided
    var title = "";
    if (targetViewId != null && targetViewId.trim().length > 0) {
      title = targetViewId.replace(/([A-Z])/g, " $1").trim();
    } else {
      var parts = monk.split(".");
      title = parts[parts.length - 1].replace(/([A-Z])/g, " $1").trim();
    }
    var msg = {
      name: title,
      description: title,
      absoluteURL: "false",
      shortcutContext: monk + ";" + area + ";" + title
    };
    //console.log('Publishing: setShortcutContext, ' + JSON.stringify(msg, null, 2));
    instance.contextMessaging.PublishContextMessage("setShortcutContext", msg);
  }
  // Put event on the events list
  addEvent(papid, pmonk, method, src, param, undefined, targetViewId);
  eventAdded(targetViewId);
}
/////////////////////////////////  Outer frame //////////////////////////////////////////////////////////////////////////////////////////////
function showApplicationHeader(show, isMaxMin) {
  if (show == undefined) show = true;
  var className = "";
  if (show && !instance.easeOfUse.hideHeader && !IsMingle()) {
    className = "showHeader";
  } else if ($("#announcementBanner").is(":visible")) {
    className = "showFullAnnouncement";
  }
  var signOut = $("#signOut");
  window.frames["menuAndView"].showOrHideSignOut(className == "" && signOut.length == 1 && !isMaxMin);
  instance.document.body.className = className;
}
function ShowHeader(vid, title, size, userName) {
  var targetViewId = vid;
  $("#inforBannerText").html(userName);
  var bannerVisible = true;
  if (document.location.search.toLowerCase().indexOf("showheader=false") < 0) {
    if (title.length == 0) title = GetViewDocument(targetViewId).title;
    // Maybe set tab title
    if (title.length > 0) {
      var table = document.getElementById("tblTabs");
      if (table) {
        // ADS 8-July-2004 - Fixed set tab title portion
        var tab = document.getElementById(vid);
        if (tab) {
          if (tab.tabName && tab.tabName.length <= 1) SetTabName(vid, title, targetViewId);
          else SetTabNameEx(tab, targetViewId);
        } else {
          SetCurrentTabTitle(title, vid, targetViewId);
        }
        if (window.contextMessaging) {
          // Send the appInitComplete message once at startup.
          if (table.rows[0].cells.length <= 3) {
            PublishContextMessage("appInitComplete", window.name);
          }
        }
      }
    } else {
      var tab = document.getElementById(vid);
      if (tab) SetTabNameEx(tab, targetViewId);
    }
  } else {
    // Set module header (for infoviewers)
    bannerVisible = false;
    // Get title from window for modal dialogs...
    if (isModal() === true) {
      if (title === "") {
        if (document && document.title) {
          title = document.title;
        }
      }
    } else if (title === "") {
      title = GetViewDocument(targetViewId).title;
    }
    window.frames["menuAndView"].updateModuleHeader(title, undefined, targetViewId);
  }
  showApplicationHeader(bannerVisible);
  _TabProc = true;
}
function GetControl(id, doc, targetViewId, type, view, endsWith) {
  var originalId = id;
  if (!id) return null;
  if (!view) {
    view = GetView(targetViewId);
  }
  var ctrl = null;
  if (view.getControl) {
    ctrl = view.getControl(id, type, endsWith);
  }
  if (!ctrl && id.indexOf("!") > -1) {
    var parentId = id.substr(0, id.indexOf("!"));
    id = id.substr(id.indexOf("!") + 1);
    var parentControl = view.getControl(parentId, endsWith);
    if (parentControl) {
      ctrl = parentControl.getChildControl(id);
    }
  }
  if (!ctrl && doc && doc.getElementById) {
    ctrl = doc.getElementById(id);
  }
  if (ctrl == undefined) {
    ctrl = view.document.getElementById(id);
    // Last ditch effort to find the control on the defined document
    if (ctrl == undefined) {
      log(
        "Could not find the control using the given id. Using GetDecoratedName failsafe code to locate control(" +
          id +
          ").",
        "error"
      );
      var jqVal = view.document.defaultView.$('[id$="' + id + '"]', doc);
      if (jqVal.length == 1) ctrl = jqVal.get(0);
      if (ctrl != null) log("Found matching control with id(" + ctrl.id + ") which will be used instead.", "error");
      else
        log(
          "Failsafe code did not return exactly 1 match(" + jqVal.length + " matches) for control id(" + id + ").",
          "error"
        );
    }
  }
  return ctrl;
}
//Downloads the given file using the hidden download frame
function DownloadFile(filename, path, targetViewId) {
  filename = urlEscape(filename);
  RedirectToDownloadFrame(
    _AppPath +
      "Core/DownloadAttachment/Download.aspx" +
      "?contentType=application%2Foctet-stream&showOpenDialog=true&fileName=" +
      filename +
      "&path=" +
      path
  );
}
function RedirectToDownloadFrame(url) {
  instance.frames["downloadFrame"].location.href = url;
}
// a hashtable mapping the Vid to an actual DOM view.  This is to reduce the need to traverse or access the DOM in order to find the view
var viewCache = new Array();
function GetCurrentView() {
  return GetView(null);
}
function AddToCache(vid, view) {
  viewCache[vid] = view;
}
// Removes the vid from the view cache if it exists there
function RemoveFromCache(vid) {
  if (vid && vid.length > 0) {
    if (viewCache[vid]) {
      viewCache[vid] = null;
      delete viewCache[vid];
    }
  }
}
function GetIFrameViewDocument() {
  var view, iFrameView;
  iFrameView = GetIFrameView();
  if (iFrameView && iFrameView.contentWindow) {
    view = iFrameView.contentWindow.document;
  }
  return view;
}
function GetIFrameView() {
  return window.frames["menuAndView"] && window.frames["menuAndView"].document.getElementById("hansenView");
}
function GetViewDocument(vid) {
  var view;
  view = GetView(vid);
  if (view) {
    return view.document;
  }
  return undefined;
}
function GetView(vid) {
  var view, iFrameView, viewFrames, table, useFrameView, doc, viewiframe, i;
  if (vid && vid.length > 0 && vid !== "undefined") {
    try {
      view = viewCache[vid];
      if (view) {
        try {
          // make sure we can access the view.  If we can't then try again and this time NOT from the cache
          // wouldn't has work better?  Or even a test on view? (view && view.document)...
          view.document;
        } catch (err) {
          view = undefined;
        }
      }
    } catch (err) {
      log(
        "Error trying to access the ViewCache for ID '" +
          vid +
          "': " +
          err +
          ". Searching the DOM for the view instead.",
        "warning"
      );
    }
    if (!view) {
      var cell = document.getElementById(vid);
      if (cell && cell.frametag) {
        view = cell.frametag.contentWindow.frames["viewTab"];
      } else {
        var iframe = GetIFrameViewDocument();
        if (iframe) {
          cell = iframe.getElementById(vid);
          if (cell && cell.frametag) {
            view = cell.frametag.contentWindow.frames["viewTab"];
          }
        }
      }
    }
  }
  if (view == undefined) {
    //else
    table = document.getElementById("tblTabs");
    if (table && table.currentCell && table.currentCell.frametag
      && table.currentCell.frametag.contentWindow
      && table.currentCell.frametag.contentWindow.frames["viewTab"])
      view = table.currentCell.frametag.contentWindow.frames["viewTab"];
    else {
      if (window.frames["menuAndView"] && window.frames["menuAndView"].MenuForm) {
        iFrameView = GetIFrameView();
        // it gets here on a popup (window.open)
        if (iFrameView) {
          if (iFrameView.contentWindow && iFrameView.contentWindow.frames) {
            viewFrames = iFrameView.contentWindow.frames;
          }
        }
      }
      useFrameView = true;
      if (viewFrames) {
        if (viewFrames["viewTab"]) {
          view = viewFrames["viewTab"];
          useFrameView = false;
        } else if (viewFrames.length > 0) {
          for (i = 0; i < viewFrames.length; i++) {
            var tab = viewFrames[i].viewTab;
            if (tab != undefined && tab.document) {
              cell = tab.document.getElementById("View");
              if (cell && cell.vid && (cell.vid === vid || vid === "")) {
                view = viewFrames[i].viewTab;
              }
            }
          }
        }
      }
      if (useFrameView) {
        view = GetIFrameView();
      }
    }
    if (view == undefined) {
      viewiframe = document.getElementsByTagName("view")[0];
      if (viewiframe) {
        doc = viewiframe.contentWindow.document;
        if (doc) {
          for (i = doc.childNodes.length - 1; i > 0; i--) {
            if (doc.childNodes[i].tagName == "IFRAME") {
              view = doc.childNodes[i].contentWindow.frames["viewTab"];
              break;
            }
          }
        }
      }
    }
  }
  if (view && !view.format && view.contentWindow) {
    view = view.contentWindow;
  }
  if (view != undefined && view._currentViewId) {
    viewCache[view._currentViewId] = view;
  }
  return view;
}
function getDummyView(targetViewId) {
  return {
    setControlValue: function() {}
  };
}
function GetHomeView(targetViewId) {
  var view, iFrameView;
  iFrameView = GetIFrameView();
  if (iFrameView) {
    if (iFrameView.contentWindow && iFrameView.contentWindow.frames) {
      var viewFrames = iFrameView.contentWindow.frames;
      if (viewFrames.frames && viewFrames.frames[0] && viewFrames.frames[0].viewTab) {
        view = viewFrames.frames[0].viewTab;
      }
    }
  }
  return view;
  //	return GetIFrameView();
}
function GetCtrlVid(ctrl, targetViewId) {
  var vid = "";
  if (ctrl && ctrl.document.forms[0] && ctrl.document.forms[0].getAttribute("vid"))
    vid = ctrl.document.forms[0].getAttribute("vid");
  return vid;
}
function GetCtrlStringRef(ctrl, targetViewId) {
  return 'GetView("' + GetCtrlVid(ctrl, targetViewId) + '").' + ctrl.id;
}
function IsDialog(targetViewId) {
  return !GetView(targetViewId).parent.document.body.getAttribute("ViewFrame");
}
function SetNavi(vid, buttons) {
  var view = GetView(vid);
  view.createNavi(vid, buttons, view);
}
function GetNaviBar(vid, targetViewId) {
  var view = GetView(vid);

  // HPS-127429: Updated to support NewExperience and Classic since NaviBar ID
  //             different for both instances.
  if(instance && instance.easeOfUse && instance.easeOfUse.useInforDesign) {
    return view.getControl("ViewBar", "ipsToolbar");
  } else {
    // "_NAVBAR_" was hardcoded in js version
    // IDS uses "ViewBar"
    return view.getControl("_NAVBAR_", "ipsToolbar");
  }
}
function HideHeader(targetViewId) {
  instance.document.body.className = "hideHeader";
}
function GetHeaderTitle(targetViewId) {
  var docForm, table;
  table = document.getElementById("tblTabs");
  if (table) {
    if (table.currentCell && table.currentCell != null) return $(table.currentCell).text();
  } else {
    docForm = GetViewDocument(targetViewId).forms[0];
    if (docForm != null && docForm.getAttribute("esubj") != null) {
      return docForm.getAttribute("esubj");
    }
  }
}
// Sets the Clean Flag on the defined form based on ViewId.
// This flag is conditionally checked in the OkayToClose method upon closing the applet.
function SetCleanFlag(val, targetViewId) {
  var targetView = GetViewDocument(targetViewId);
  if (targetView && targetView.forms[0]) targetView.forms[0].setAttribute("isClean", val);
}
// Sets the Check Clean Flag on the defined form based on ViewId.
// This flag is conditionally checked in the OkayToClose method upon closing the applet.
// If true, the clean flag will be checked when closing the applet.
// If false, will bypass checking to display the warning message
function SetCheckCleanFlag(val, targetViewId) {
  var targetView = GetViewDocument(targetViewId);
  if (targetView && targetView.forms[0]) targetView.forms[0].setAttribute("chkClean", val);
}
var _closeDelegate; // Close delegate for close confirmations
function SetCloseDelegate(delegate) {
  _closeDelegate = null; // clear delegate
  _closeDelegate = delegate;
}
function RunCloseDelegate() {
  if (_closeDelegate) {
    _closeDelegate();
    _closeDelegate = null; // clear delegate
  }
}
function CreateTrackingClient(ifsUser, ifsSession) {
  if (InforUserAnalyticsEnabled && InforUserAnalyticsBaseUrl != "") {
    return new yggdrasil.StandaloneTrackingClient({
      auth: {
        type: "custom",
        login: async function () {
          var regex = /^((http|https):\/\/.*?)\/.*/i;
          var domain = regex.exec(document.URL)[1];
          var rootPath = _ClientPath.replace(/(Client\/)/i, "");
          var endpointUrl = common.combine(domain, rootPath, "api/useranalytics/auth?IFSUserId=" + ifsUser + "&IFSSessionGUID=" + ifsSession);
          console.log("[Yggdrasil] Proxy url is: " + endpointUrl);
          var response = await fetch(endpointUrl, {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json'
            },
          });
          var jsonResponse = await response.json();
          return {
            accessToken: jsonResponse.data.accessToken,
            refreshToken: jsonResponse.data.refreshToken,
            expiresIn: jsonResponse.data.expiresIn,
            tokenType: jsonResponse.data.tokenType,
            baseUrl: InforUserAnalyticsBaseUrl
          };
        },
      },
      trackingStrategy: "CUSTOM",
    });
  }
  else {
    return new yggdrasil.DevTrackingClient();
  }
}

function StartTrackingView(viewname, viewurl, viewid, ifsUser, ifsSession, userfeatures, controlsToTrack) {
  var frm = this;
  if (isChildWindow() || isModal()) {
    try {
      frm = instance.opener;
    }
    catch (e) {
      log("Parent window is closed. Reauthenticating Infor User Analytics.");
    }
  }
  // If the tracking client is not created, create it
  if (frm.InforUserAnalyticsTrackingClient == null) {
    if (frm.InforUserAnalyticsTrackingClient == null) {
      frm.InforUserAnalyticsTrackingClient = CreateTrackingClient(ifsUser, ifsSession);
    }
  }

  // Infor User Analytics tags have a limit of 16 characters
  // Parse the incoming user features and shorten them if necessary
  var shortenedUserFeatures = [];
  // Constrain userfeatures to a maximum of 10. Infor User Analyitics does not accept more than 10 features
  for (var j = 0; j < Math.min(userfeatures.length, 10) ; j++) {
    // Try getting the last part of feature id of format "Hansen.FamilyName.Namespace.featureName"
    var featureName = userfeatures[j].split('.').pop();
    // If the feature name is still longer than 16 characters, no choice but to truncate it
    if (featureName.length > 16) {
      featureName = featureName.substring(0, 16);
    }
    shortenedUserFeatures.push(featureName);
  }

  // Temporary Polyfill for randomUUID. Not sure why this isn't available in some on prem sites, but adding this as a stopgap to prevent the same error in production. 
  // RandomUUID will be called in frm.InforUserAnalyticsApplicationTracker.trackStart(); in the underlying IUA code. 
  // AI Generated - Also compared to valid existing polyfill of randomUUID
  if (!crypto.randomUUID) {
    crypto.randomUUID = function () {
        return ([1e7]+-1e3+-4e3+-8e3+-1e11).replace(/[018]/g, c =>
            (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
        );
    };
  }
  // End AI Generated

  // If the application tracker is not created, create it and start tracking
  if (frm.InforUserAnalyticsApplicationTracker == null) {
    frm.InforUserAnalyticsApplicationTracker = new yggdrasil.ApplicationTracker({
      name: "Public Sector",
      trackingClient: frm.InforUserAnalyticsTrackingClient,
      identifier: "lid://infor.ips",
      features: shortenedUserFeatures
    });

    frm.InforUserAnalyticsApplicationTracker.trackStart();
    frm.addEventListener("unload", () => {
      frm.InforUserAnalyticsApplicationTracker.trackEnd();
      console.log("[Yggdrasil] Application tracking ended.");
    });
  }
  // Get the view
  var view = GetView(viewid);

  // Create a new Infor User Analytics view tracker

  // Get the list of features active on this page. Shorten them to 16 characters if necessary
  var activeFeatures = [];
  // HPS-131421 Needed to restrict features to 10. Infor User Analytics does not accept more than 10 features per view. 
  for (var k = 0 ; k < Math.min(controlsToTrack.length , 10); k++) {
    var controlFeatureName = TruncateFeatureID(controlsToTrack[k].feature);
    if (activeFeatures.indexOf(controlFeatureName) == -1) {
      activeFeatures.push(controlFeatureName);
    }  
  }

  view.IUAViewTracker = frm.InforUserAnalyticsApplicationTracker.createView({
    name: viewname,
    url: viewurl,
    identifier: viewname + "_id",
    features: activeFeatures
  });

  // Start tracking the new view
  if (view.IUAViewTracker) {
    view.IUAViewTracker.trackStart();
  }

  // Add an event listener to track the end of the view
  view.addEventListener("unload", () => {
    view.IUAViewTracker.trackEnd();
    console.log("[Yggdrasil] View Unloaded");
  });  
}

// Sets up all automatic click trackers for controls decorated with the FeatureToggleId attribute
function SetupFeatureTrackers(viewid, controlsToTrack) {
  try {
    // Get the view from the viewid
    var view = GetView(viewid);

    // For each control to track, add an event listener to track the feature
    for (var i = 0 ; i < controlsToTrack.length; i++) {
      var control = controlsToTrack[i].id;
      var controlElement = view.getControl(control);
      var featureName = TruncateFeatureID(controlsToTrack[i].feature);
      if (controlElement) {
        controlElement.element[0].addEventListener("click", () => {
          view.IUAViewTracker.trackEvent("Feature Control Clicked", "click", {}, [], [featureName]);
        });
      }
    }
  }
  catch (ex) {
    log("Unable to setup automatic feature interaction tracking. " + ex);
  }
  
}

// Command function to start tracking a specific feature control
function StartTrackingFeatureControl(viewid, ctrlid, eventName, featureid){
  try {
    var view = GetView(viewid);
    var control = view.getControl(ctrlid);
    if (control) {
      control.element[0].addEventListener(eventName, () => {
        view.IUAViewTracker.trackEvent("Feature Control " + eventName, eventName, {}, [], [TruncateFeatureID(featureid)]);
      });
      if (view.IUAViewTracker.features.indexOf(TruncateFeatureID(featureid)) == -1) {
        view.IUAViewTracker.features.push(TruncateFeatureID(featureid));
      }
    }
  }
  catch (ex) {
    log("Unable to track feature control: " + ex);
  }
}

// Returns the truncated feature name
function TruncateFeatureID(featureId) {
  var featureNameSplit = featureId.split('.');
  var featureName = featureNameSplit.pop();
  if (featureName.length > 16) {
    featureName = featureName.substring(0, 16);
  }
  
  return featureName;
}

// This function resizes all the views to match the main view frame, following a
// change in the frame sizes.  It is necessary to call this function after  HideMenu( targetViewId )
// or ShowMenu( targetViewId).
function ResizeAllViews(targetViewId) {
  var view, iframes, i;
  view = GetIFrameView();
  iframes = view.frames;
  if (iframes) {
    for (i = 0; i < iframes.length; i++) {
      iframes[i].frameElement.style.width = view.document.body.offsetWidth;
    }
  }
}
/////////////   MENU HIDING  ///////////////
//var menuSize = 100;
var menuLoaded = false;
var bannerVisible = true;
function ToggleMenuVisibility(targetViewId) {}
var _AutoHideOn = false;
function SetAutoHide(bOnOff, targetViewId) {
  _AutoHideOn = bOnOff;
}
function AutoHideMenu(targetViewId) {}
function HideMenu(bRemove, targetViewId) {
  var menuAndView = instance.document.getElementsByName("menuAndView")[0];
  var menu = instance.frames["menuAndView"].document.getElementById("MenuCell");
  if (menu) {
    menu.style.display = "none";
  }
  if (bRemove == undefined || bRemove == true) {
    menuLoaded = false;
  }
}
function ShowMenu(targetViewId) {
  var search = instance.document.location.search.toLowerCase();
  if (search.indexOf("showmenu=false") < 0 && search.indexOf("hasmenu=false") < 0) {
    var menuAndView = instance.frames["menuAndView"];
    var useInforDesign = instance.easeOfUse.useInforDesign;
    if (menuAndView) {
      if (!menuLoaded) {
        instance.isMenuLoading = true;
        var temp = document.location.pathname + (useInforDesign === true ? "/../MenuIDS.aspx" : "/../Menu.aspx");
        if (temp.substring(0, 1) != "/") temp = "/" + temp;
        instance.frames["menuAndView"].document.location.replace(temp + "?showmenu=true");
        menuLoaded = true;

        loadMyHansenApplet();
      }
    }
  }
}

function loadMyHansenApplet() {
  setTimeout(() => {
    tryLoadMyHansenApplet();
  }, 250);
}

function tryLoadMyHansenApplet() {  
  if (instance.isMenuLoading) {
    setTimeout(() => {
      tryLoadMyHansenApplet();
    }, 250);
  }
  else {
    instance.addEvent("", "Hansen.MyHansen.MyHansenApplet", "InitView", "", "");
    instance.sendEvents();
  }
}

/////////////   END MENU HIDING  ///////////////
function MenuClick(ruleId, value, title, apid, targetViewId, appletParams) {
  var vid;
  if (ruleId.toLowerCase() == "menuclick") {
    vid = menuLoadView(apid, value, title, targetViewId, appletParams);
  } else {
    //clearlog( targetViewId);
    //log( 'MenuClick( '+ruleId+', '+value+', '+title+' , targetViewId)' );
    addEvent(
      apid,
      "Hansen.MyHansen.MyHansenApplet",
      ruleId,
      "",
      "<PARAM val='" + value + "' /><PARAM val='" + title + "'/>",
      undefined,
      targetViewId
    );
    eventAdded(targetViewId);
  }
  return vid;
}
// Redirects the view frame to load a page
function menuLoadView(apid, monk, title, targetViewId, appletParams) {
  var vid = "v_" + Math.floor(Math.random() * 100000);
  AddTask(" ", "", monk, apid, vid, true, targetViewId, appletParams, title);
  SetCurrentTabTitle(title, vid, targetViewId);
  return vid;
}
// Test to see if the current window is a Hansen child window.
function isChildWindow() {
  var child = false;
  try {
    // we are only going to have dialogArguments when the window is opened using showModalDialog
    var hasDialog = instance.dialogArguments != null;
    // if GetView does not exist then that means that the opener is not H8 and some other site
    // for IE if the window is a modal window (showModalDialog) then the opener will be NULL however for Chrome the window will have an opener
    // regardless of how it was opened
    if (instance.opener && (instance.opener.GetView || instance.opener.AddTask) && !hasDialog) child = true;
  } catch (err) {}
  return child;
}
// Common client-side exception handler
function clientException(title, err, targetViewId) {
  _Ready = true;
  fireClientErrorEvent(
    title,
    err.message,
    "<CLEX num='" + err.number + "' name='" + err.name + "' desc='" + xmlEscape(err.description) + "'/>",
    targetViewId
  );
}
function readyForError(targetViewId) {
  var ready = true;
  var viewDoc = GetViewDocument(targetViewId);
  var frames = instance.frames;
  if (frames) {
    if (window.frames["cblock"] && window.frames["cblock"].document) {
      ready = window.frames["cblock"].document.readyState == "complete";
    }
  }
  if (viewDoc) {
    ready &= viewDoc.readyState == "complete";
  }
  return ready;
}
// Creates a client request for an error message
function fireClientErrorEvent(title, msg, detail, targetViewId) {
  // ADS 12-March-2004 - Changed to work when the view is still loading
  if (readyForError(targetViewId)) {
    var request = "<ERRMSG title='" + xmlEscape(title) + "' msg='" + xmlEscape(msg) + "'>";
    if (window.frames["cblock"] && window.frames["cblock"].document)
      request += "<CBLOCK>" + xmlEscape(window.frames["cblock"].document.forms[0].innerHTML) + "</CBLOCK>";
    var viewDoc = GetViewDocument(targetViewId);
    if (viewDoc) {
      request += "<VIEW>" + xmlEscape(viewDoc.body.outerHTML) + "</VIEW>";
    }
    request += "<DETAIL>" + xmlEscape(detail) + "</DETAIL>";
    if (window._logHistory && window._logHistory.length > 0) {
      request += "<LOGS>";
      for (var i = 0; i < window._logHistory.length; i++) {
        request += "<LOG>" + xmlEscape(window._logHistory[i]) + "</LOG>";
      }
      request += "</LOGS>";
    }
    request += "</ERRMSG>";
    sendCustomRequest(request, targetViewId);
  } else {
    setTimeout(function() {
      fireClientErrorEvent(title, msg, detail, targetViewId);
    }, 100);
  }
}
// Shows the error message box (called from server)
// ADS  3-Feb-2004 - Expanded to include message details
// ADS 12-Oct-2004 - Expanded to handle callback request
function openErrorMsg(title, msg, details, email, logFileName, froot, fpath, dev, ann, targetViewId, callback) {
  var e = SystemEvents("messageDialogOpened", targetViewId).trigger(title, msg);
  if (e.result) {
    var view = GetView(targetViewId);
    if (view.showErrorMessage) {
      view.showErrorMessage(title, msg, details, email, logFileName, froot, fpath, dev, ann, callback);
    } else {
      $("body").message({
        title: title,
        shortMessage: msg,
        detailedMessage: details,
        dialogType: "Error"
      });
    }
  } else if (callback) {
    callback();
  }
}
//
//08/21/06 cpb Russ added this function for modal closing problem
//Opens a Hansen dialog and flags the current window as having a modal open.  If
//the parent tries to KAI on the child and a modal is open, it will just exit
function openHansenDialog(url, args, opts, buttons, targetViewId) {
  opts = opts.replace(/,/g, ";");
  args.opener = top;
  window.hasOpenModal = true;
  var ret = showModalDialog(url, args, opts, buttons);
  //window.open(url);
  window.hasOpenModal = false;
  return ret;
}
// Shows a message box
function openMessageBox(
  type,
  title,
  msg,
  icon,
  buttons,
  applet,
  moniker,
  method,
  techsupportemail,
  http,
  file,
  err,
  errmsg,
  width,
  height,
  resizable,
  targetViewId,
  callBack
) {
  GetView(targetViewId).showMessageBox(
    type,
    title,
    msg,
    icon,
    buttons,
    applet,
    moniker,
    method,
    techsupportemail,
    err,
    errmsg,
    resizable,
    targetViewId,
    callBack
  );
}
function SavePreferences(ctrl, xml, id) {
  // if we did not specify an ID then use the id from the control
  if (!id) {
    id = ctrl.id;
  }
  iQuery.H8.callApplet("ProcessPreferences", { 0: getPrefsXml(id, xml) }, ctrl);
}
function getPrefsXml(id, xml) {
  var req = new Array();
  req.push("<PREF id='");
  req.push(id);
  req.push("' ");
  if (xml) {
    req.push(xml);
  } else {
    req.push(_Prefs[id]);
  }
  req.push(" />");
  return req.join("");
}
function constructPrefs(ctrl, type, targetViewId) {
  var base = findEM(ctrl, targetViewId);
  var pathname = ctrl.ownerDocument.location.pathname;
  var page = pathname.substr(pathname.lastIndexOf("/") + 1);
  var xml = "page='" + page + "' type='" + type + "'";
  if (base) xml += " apid='" + base.getAttribute("apid") + "' monk='" + base.getAttribute("monk") + "'";
  return xml;
}
function setControlPrefValue(ctrl, id, type, val, targetViewId) {
  if (_Prefs == null) _Prefs = {};
  var xml = _Prefs[ctrl.id];
  if (xml == undefined) {
    xml = constructPrefs(ctrl, type, targetViewId);
  }
  var start = xml.indexOf(id + "='");
  if (start > -1) {
    start += id.length + 2;
    xml = xml.substr(0, start) + val + xml.substr(xml.indexOf("'", start));
  } else xml += " " + id + "='" + val + "'";
  _Prefs[ctrl.id] = xml;
  return xml;
}
/***** CLIENT IMAGE CACHE ******/
var _cache = {};
// Adds an image to the client cache
function addImgCache(path, id, targetViewId) {
  if (_cache[id] == undefined) {
    var img = new Image();
    img.src = path;
    _cache[id] = img;
  }
}
// Retrieves an image from the cache
function getCachedImage(id, targetViewId) {
  var src = null;
  if (_cache[id] && _cache[id].src) src = _cache[id].src;
  return src;
}
function MapDrawerCallProxy(theCall, targetViewId) {
  eval(theCall);
}
// Retrieves the server locale specification
function getLocaleSpecifier() {
  return _Locale;
}
// Returns the Currency Decimal Separator
function getNumberDecimalSeparator(targetViewId) {
  return _NumberDecimalSeparator;
}
// Returns the Currency Group Separator, ie. 1000's separator
function getNumberGroupSeparator(targetViewId) {
  return _NumberGroupSeparator;
}
///
///Pass any hotkeys off to the global event handler
///
function handleKeyDownGlobal(e, targetViewId) {
  var currentView;
  if (GetView != undefined) {
    currentView = GetView(targetViewId);
    if (currentView != null && currentView.handleKeyCode) {
      return currentView.handleKeyCode(e);
    }
  }
  return true;
}
/* Adds an array of scripts or CSS content file to the document */
// Composite values ( <PARAM key='val' type='type' disp='val'/>
function getCompositeDisplay(src) {
  var disp = src.substr(src.indexOf("disp") + 6);
  if (disp.indexOf("'") > -1) disp = disp.substr(0, disp.indexOf("'"));
  else if (disp.indexOf('"') > -1) disp = disp.substr(0, disp.indexOf('"'));
  return disp;
}
function getCompositeKey(src) {
  // OP PR#101739.  This was stripping off the first 4 characters of each key
  var disp = src; //src.substr( src.indexOf( "key" ) + 5 );
  if (disp.indexOf("'") > -1) disp = disp.substr(0, disp.indexOf("'"));
  else if (disp.indexOf('"') > -1) disp = disp.substr(0, disp.indexOf('"'));
  return disp;
}
function makeComposite(key, display) {
  return "<PARAM key='" + key + "' disp='" + display + "'/>";
}
function signOut() {
  var view = GetCurrentView();

  // Stop device polling loop to prevent 401
  try {
    getDeviceControlView().stopPollingLoop();
  } catch (e) {
    log("Error occured shutting down device polling loop. " + e);
  }

  if (view && view.queueEvent) {
    try {
      closeChildren(view.id, true);
      view.queueEvent("DefaultLogOffRule", "", null, "", false, view.id);
    } catch (e) {
      log("Log off error occured. " + e);
    }
  }
}
// makes an ajax request to save the new menu and header toggles
function saveHeaderMenuChanges() {
  var view = GetView();
  var form = view.document.forms[0];
  //"Hansen8", "General", "MenuCollapse"
  iQuery.H8.callApplet(
    "SaveSinglePreference",
    new view.Array("MenuCollapse", "General", instance.easeOfUse.hideMenu + "", "System.Boolean"),
    form,
    null,
    function(exception) {
      var msg = exception.Message || "Automatically saving the changes was not successful";
      view.SetPageLevelMessage("Saving Error", msg, true);
    }
  );
  //"Hansen8", "General", "HeaderHidden"
  iQuery.H8.callApplet(
    "SaveSinglePreference",
    new view.Array("HeaderHidden", "General", instance.easeOfUse.hideHeader + "", "System.Boolean"),
    form,
    null,
    function(exception) {
      var msg = exception.Message || "Automatically saving the changes was not successful";
      view.SetPageLevelMessage("Saving Error", msg, true);
    }
  );
}
// cleans up any remaining items on the document before switching tabs or views
function cleanupPage(doc, jquery) {
  // grid comments
  var tabButton = jquery(".inforTabButton[aria-expanded='true']").data("popupmenu");
  if (tabButton) {
    tabButton.close(true);
  }
  var attMenu = jquery("button.ipsAttachmentModuleHeader[aria-expanded='true']").data("popupmenu");
  if (attMenu) {
    attMenu.close(true);
  }
  var gridMenu = jquery("button.inforGridSettingsButton[aria-expanded='true']").data("popupmenu");
  if (gridMenu) {
    gridMenu.close(true);
  }
  jquery(".inforPopover", doc).remove();
}

function loadCblockFromString(content)
{
	setTimeout(function ()
	{
		instance.cblock.document.open();
		instance.cblock.document.write(content);
		instance.cblock.document.close();
	}, 0);
}
